<div fxLayout="column"
  fxLayoutGap="2rem">
  <div class="dialog-title-container"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="1rem">
    <div class="font-size-large-container bold-container">Cell Phone Update</div>
    <mat-icon class="material-symbols-outlined pointer-cursor"
      id="cellphone-update-close-button"
      (click)="close()">
      close
    </mat-icon>
  </div>
  <form [formGroup]="form">
    <mat-form-field class="full-width-container"
      appearance="outline"
      subscriptSizing="dynamic"
      [hideRequiredMarker]="true">
      <input matInput
        phoneNumberMask
        required
        autocomplete="tel"
        formControlName="cellPhoneControl"
        maxlength="14"
        name="mobile"
        placeholder="Cell Phone"
        type="text">
        <mat-hint>(text and data rates may apply)</mat-hint>
        @if (cellphoneRequired()) {
          <mat-error>
            Cell phone is <strong>required</strong>
          </mat-error>
        }
        @if (validCellphoneRequired()) {
          <mat-error>
            A valid phone number is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
      <app-loading-button id="update-phone-number-button"
        fxLayoutAlign="end"
        [buttonText]="'Update'"
        [request$]="save$"
        (clickEvent)="save()">
      </app-loading-button>

    </form>
  </div>